import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ilk_cookie_consent")) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("ilk_cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[100] border border-zinc-800 bg-zinc-900 rounded-xl p-5 shadow-2xl shadow-black/50"
      data-testid="cookie-consent-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-teal-400 mt-0.5 shrink-0" />
        <div className="flex-1">
          <p className="text-sm text-zinc-300 leading-relaxed">
            We use essential session cookies to keep you signed in. No tracking or ad cookies. See our{" "}
            <Link to="/privacy" className="text-teal-400 hover:text-teal-300 underline underline-offset-2" data-testid="cookie-privacy-link">
              Privacy Policy
            </Link>
            .
          </p>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="mt-4 bg-teal-400 text-zinc-950 text-sm font-semibold py-2 px-5 rounded-xl hover:bg-teal-300 transition-colors duration-200 active:scale-95"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
